import { Alert, Divider, Grid, Typography } from "@mui/material";
import { useEffect } from "react";
import { UseFormReturn, useWatch } from "react-hook-form";
import { AsyncSelect, ControlledTextField } from "src/components/forms";
import CardActions from '../../../components/CardActions';
import { SectionBox } from '../../../components/FieldView';
import { useADCMTransaccionTipos } from "../hooks/useADCMCache";
import { loadSiNoOptions } from "../hooks/useOpcionesGenericas";
import { ADCMTransaccionTipo } from "../types/enum";
import { OperacionADCMFields } from "../types/fields";

interface SeccionNuevoADCMDetalleTransaccionProps {
  formMethods: UseFormReturn<any>,
  codPais: number
}

export const SeccionNuevoADCMDetalleTransaccion = ({ formMethods, codPais }: SeccionNuevoADCMDetalleTransaccionProps) => {
  const { control, setValue } = formMethods;

  const { transaccionTipos } = useADCMTransaccionTipos(codPais);

  const watchedTransaccionId = useWatch({ control, name: OperacionADCMFields.CodTransaccionTipo });
  const watchedVirtual = useWatch({ control, name: OperacionADCMFields.CodVirtualTransaccion });

  useEffect(() => {
    if (watchedTransaccionId && transaccionTipos) {
      const seleccionado = transaccionTipos.find((t: any) => t.id === watchedTransaccionId);
      setValue(OperacionADCMFields.CodVirtualTransaccion, seleccionado?.codVirtual);
    }
  }, [watchedTransaccionId, transaccionTipos, setValue]);

  const esDCMoABS = watchedVirtual === ADCMTransaccionTipo.DCM || watchedVirtual === ADCMTransaccionTipo.ABS;
  const esECM = watchedVirtual === ADCMTransaccionTipo.ECM;
  const esABS = watchedVirtual === ADCMTransaccionTipo.ABS;
  const mostrarSeccion = esDCMoABS || esECM;

  return (
    <CardActions title='Detalle de la Transacción' icon='mdi:swap-horizontal' colapsable>
      {!mostrarSeccion ? (
        <Alert severity='info'>Seleccione un tipo de transacción</Alert>
      ) : (
        <Grid container spacing={2.5}>

          {/* Datos financieros base (DCM, ECM, ABS) */}
          <Grid item xs={12}>
            <SectionBox>
              <Grid item xs={12}>
                <ControlledTextField label='Monto' name={OperacionADCMFields.Monto} control={control} fullWidth currency />
              </Grid>
              <Grid item xs={12}>
                <ControlledTextField label='Tipo de Moneda' name={OperacionADCMFields.Moneda} control={control} fullWidth />
              </Grid>
              <Grid item xs={12}>
                <ControlledTextField label='Fee' name={OperacionADCMFields.Fee} control={control} fullWidth />
              </Grid>
              <Grid item xs={12}>
                <ControlledTextField label='Destino de fondos' name={OperacionADCMFields.DestinoFondos} control={control} fullWidth />
              </Grid>
            </SectionBox>
          </Grid>

          {/* Estructura de deuda (DCM y ABS) */}
          {esDCMoABS && (
            <>
              
              <Grid item xs={12}>
                <SectionBox>
                  <Grid item xs={12}>
                    <ControlledTextField label='Cupón de la transacción' name={OperacionADCMFields.CuponTransaccion} control={control} fullWidth />
                  </Grid>
                  <Grid item xs={12}>
                    <ControlledTextField label='Cadencia de pago de cupón' name={OperacionADCMFields.CadenciaPagoCupon} control={control} fullWidth />
                  </Grid>
                  <Grid item xs={12}>
                    <ControlledTextField label='Plazo al vencimiento' name={OperacionADCMFields.PlazoVencimiento} control={control} fullWidth />
                  </Grid>
                  <Grid item xs={12}>
                    <ControlledTextField label='Cadencia de amortización' name={OperacionADCMFields.CadenciaAmortizacion} control={control} fullWidth />
                  </Grid>
                  <Grid item xs={12}>
                    <AsyncSelect
                      label='Contrato exclusividad'
                      name={OperacionADCMFields.ContratoExclusividad}
                      loadOptions={loadSiNoOptions}
                      control={control}
                      fullWidth
                      selectNotNulleable
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <ControlledTextField label='Co-Colocadores' name={OperacionADCMFields.Colocadores} control={control} fullWidth />
                  </Grid>
                </SectionBox>
              </Grid>
            </>
          )}

          {/* Garantías (ABS) */}
          {esABS && (
            <>
              <Grid item xs={12}>
                <Divider textAlign='left'>
                  <Typography variant='caption' color='text.secondary' sx={{ textTransform: 'uppercase', letterSpacing: '0.08em' }}>
                    Garantías
                  </Typography>
                </Divider>
              </Grid>
              <Grid item xs={12}>
                <SectionBox>
                  <Grid item xs={12}>
                    <ControlledTextField label='Garantías' name={OperacionADCMFields.Garantias} control={control} fullWidth />
                  </Grid>
                </SectionBox>
              </Grid>
            </>
          )}

        </Grid>
      )}
    </CardActions>
  );
};
